import React from 'react';
import { motion } from 'framer-motion';
import { FaPhone, FaCreditCard, FaCar } from 'react-icons/fa';

const HowItWorks = () => {
  const steps = [
    {
      icon: <FaPhone size={40} />,
      title: "1. Schedule Your Ride",
      description: "Call our Dispatchers",
      phoneNumber: "360-482-3996"
    },
    {
      icon: <FaCreditCard size={40} />,
      title: "2. Payment Method",
      description: "Select your preferred payment method"
    },
    {
      icon: <FaCar size={40} />,
      title: "3. Get Picked Up",
      description: "Our driver picks you up at the scheduled location and time"
    }
  ];

  return (
    <section className="how-it-works" id="how-it-works">
      <div className="container">
        <motion.div
          className="intro-text"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <h2>How does it work?</h2>
          <p className="tagline">It is just three simple steps.</p>
        </motion.div>

        <div className="steps-grid">
          {steps.map((step, index) => (
            <motion.div
              className="step-card"
              key={index}
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ 
                duration: 0.6,
                delay: index * 0.2 
              }}
              whileHover={{ 
                scale: 1.03,
                boxShadow: "0 10px 20px rgba(0,0,0,0.1)"
              }}
            >
              <div className="step-icon">
                {step.icon}
              </div>
              <h3>{step.title}</h3>
              <p>{step.description}</p>
              {step.phoneNumber && (
                <a href={`tel:${step.phoneNumber}`} className="phone-link">
                  {step.phoneNumber}
                </a>
              )}
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowItWorks; 